import External from "@common/components/icons/External";
import { persistUTMQueryParamsToUrlObject } from "@common/utils/router";
import { Anchor, Flex, Text } from "@mantine/core";
import Link from "next/link";
import { useRouter } from "next/router";

export function ManageAddOnLink({
  href,
  hrefLabel,
  hasAddOn,
}: {
  href: string;
  hrefLabel?: string;
  hasAddOn: boolean;
}) {
  const router = useRouter();
  const isExternalLink = href?.startsWith("http");

  return (
    <Text fw={700} fz="sm">
      <Anchor
        component={Link}
        href={persistUTMQueryParamsToUrlObject(router, href)}
        target={isExternalLink ? "_blank" : undefined}
        fw={700}
        fz="sm"
      >
        <Flex align="center" direction="row" gap="xs">
          {hasAddOn ? (hrefLabel ?? "Manage") : "Enable"}
          {isExternalLink && <External />}
        </Flex>
      </Anchor>
    </Text>
  );
}
